export default class SaveGameEvent {
    constructor(type) {
        this._type = type;
    }

    get type() {
        return this._type;
    }
}

SaveGameEvent.SAVE = "SaveGameEvent.SAVE";
SaveGameEvent.LOAD = "SaveGameEvent.LOAD";
SaveGameEvent.GAME_SAVED = "SaveGameEvent.GAME_SAVED";
SaveGameEvent.GAME_LOADED = "SaveGameEvent.GAME_LOADED";
SaveGameEvent.SHOW_PENDING_FEEDBACK = "SaveGameEvent.SHOW_PENDING_FEEDBACK";